import injectSheet from 'react-jss';
import theme, { em, expandAbsolutely } from '../../styles/theme';
import round from '../../helpers/round';
import { resolvePosition } from '../Header/container';

const WAITLIST_ASPECT_DESKTOP = 12 / 5;
const WAITLIST_ASPECT_MOBILE = 4 / 3;

const fontSizes = {
  sm: 14,
  md: 16,
  lg: 20,
};

export default injectSheet({
  root: {
    fontSize: fontSizes.sm,
    color: theme.colors.white,
    width: '100%',
    position: 'relative',
    paddingTop: `${round(100 / WAITLIST_ASPECT_MOBILE)}%`,
    [theme.breakpoints.up('md')]: {
      fontSize: fontSizes.md,
      paddingTop: `${round(100 / WAITLIST_ASPECT_DESKTOP)}%`,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: fontSizes.lg,
    },
    '&.dark': {
      color: theme.colors.brandBlack,
    },
  },
  image: {
    ...expandAbsolutely,
  },
  content: {
    flex: '0 1 100%',
    [theme.breakpoints.up('md')]: {
      flexBasis: '50%',
    },
  },
  titleContainer: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'flex-end',
    },
  },
  title: {
    color: 'inherit',
    fontFamily: theme.fonts.bold,
    fontWeight: theme.fonts.boldWeight,
    fontSize: 32,
    lineHeight: 1.5,
    letterSpacing: 0.3,
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: ({ alignment }) => resolvePosition(alignment.mobile),
    [theme.breakpoints.up('md')]: {
      justifyContent: ({ alignment }) => resolvePosition(alignment.desktop),
      fontSize: 40,
    },
    '& span': {
      fontSize: 14,
      fontFamily: theme.fonts.body,
      fontWeight: theme.fonts.bodyWeight,
      whiteSpace: 'nowrap',
      color: theme.colors.ui03,
      letterSpacing: 0.3,
      lineHeight: 1.43,
      position: 'relative',
      paddingLeft: '1em',
      marginLeft: '0.75em',
      top: -0.75,
      '&:before': {
        content: '""',
        ...expandAbsolutely,
        top: -1,
        width: 1.5,
        height: 14,
        backgroundColor: theme.colors.white,
        margin: 'auto 0',
      },
    },
  },
  countdownContainer: {
    marginTop: theme.spacing.vertical.xxs / 2,
    marginBottom: theme.spacing.vertical.md / 2,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.vertical.md,
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: 4 * theme.spacing.vertical.sm - 4,
    },
  },
  countdown: {
    color: 'inherit',
    fontSize: em(fontSizes, 32, 'sm'),
    letterSpacing: 0.3,
    marginTop: theme.spacing.vertical.xxs,
    fontFamily: theme.fonts.body,
    fontWeight: theme.fonts.boldWeight,
    justifyContent: ({ alignment }) => resolvePosition(alignment.mobile),
    '&.formVisible': {
      display: 'none',
    },
    [theme.breakpoints.up(theme.breakpoints.wideMobile)]: {
      fontSize: em(fontSizes, 42),
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: ({ alignment }) => resolvePosition(alignment.desktop),
      '&.formVisible': {
        display: 'block',
      },
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: em(fontSizes, 52, 'lg'),
    },
  },
  darkWrapper: {
    color: theme.colors.black,
  },
  lightWrapper: {
    color: theme.colors.white,
  },
  desktopDarkWrapper: {
    [theme.breakpoints.up('md')]: {
      color: theme.colors.black,
    },
  },
  desktopLightWrapper: {
    [theme.breakpoints.up('md')]: {
      color: theme.colors.white,
    },
  },
});
